var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankIconSample({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.45101 0.0198744C4.59887 -0.0497677 5.7596 0.471326 6.47571 1.36751C7.19396 2.23284 7.45411 3.44241 7.17711 4.52828C6.92002 5.58299 6.15396 6.49719 5.16422 6.94651C4.5197 7.24349 3.80187 7.34524 3.09985 7.23912C1.97436 7.07785 0.948761 6.35333 0.423859 5.34779C0.137374 4.80864 -0.00827086 4.20626 0.000362646 3.59621C0.00899615 2.98616 0.17163 2.3881 0.473258 1.85722C0.774886 1.32635 1.20579 0.879745 1.72621 0.558631C2.24664 0.237516 2.83981 0.0522318 3.45101 0.0198744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.2985 0.181436C10.3297 0.118966 10.3646 0.0583822 10.403 0C9.26597 5.24352 8.12802 10.487 6.98915 15.7305C6.75259 16.8091 6.52369 17.8891 6.28438 18.9683C4.27813 18.9669 2.27188 18.9669 0.265625 18.9683C3.61299 12.7072 6.95728 6.44494 10.2985 0.181436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.6189 0.0117188C12.3237 0.0117188 12.0285 0.0117188 12.7332 0.0117188C11.5764 5.32813 10.4217 10.6449 9.26914 15.9619C9.05464 16.9634 8.83034 17.9635 8.61983 18.966C7.91322 18.966 8.20661 18.9638 7.5 18.966C8.87379 12.6483 10.2468 6.3302 11.6189 0.0117188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.8384 0.0117188C15.8449 0.0117188 17.8514 0.0117188 19.8578 0.0117188C16.4804 6.33509 13.1033 12.6587 9.72656 18.9824C9.81205 18.5102 9.92758 18.0438 10.0253 17.574C11.2955 11.7198 12.5666 5.86572 13.8384 0.0117188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.0244 12.7841C14.731 12.0511 15.767 11.6522 16.7843 11.7013C17.3314 11.7267 17.8657 11.8747 18.3475 12.1343C18.8293 12.3938 19.2463 12.7583 19.5673 13.2006C19.8884 13.6429 20.1054 14.1516 20.202 14.689C20.2987 15.2263 20.2727 15.7785 20.1259 16.3044C19.8299 17.3869 18.9979 18.3057 17.9484 18.7107C17.1487 19.026 16.2626 19.0476 15.4483 18.7718C14.6201 18.4901 13.92 17.9227 13.4744 17.1719C13.0676 16.4823 12.9011 15.678 13.0009 14.8843C13.1006 14.0906 13.461 13.352 14.0259 12.7838",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIconSample);
export default __webpack_public_path__ + "static/media/bankIconSample.2d4629c6c60b32ad2d0c9c898dd2546a.svg";
export { ForwardRef as ReactComponent };